import { BaseLink } from '~components/BaseLink';
import { documentToReactComponents, Options } from '@contentful/rich-text-react-renderer';
import { INLINES, Text } from '@contentful/rich-text-types';
import React from 'react';
import { tildeToSoftHyphen, UniqueIdStorage } from './string';

export type RawContent = string;
export type RawContentOptions = Options;

/**
 * Add defaults for Contentful Rich Text document
 */
export function rawContentToReactComponents(
  rawContent: RawContent,
  { renderNode = {}, ...otherRenderOptions }: RawContentOptions = {},
) {
  const uniqueIdStorage = new UniqueIdStorage();

  return documentToReactComponents(JSON.parse(tildeToSoftHyphen(rawContent)), {
    renderNode: {
      [INLINES.HYPERLINK]: (node, children) => {
        const textContent = (node.content[0] as Text)?.value;
        return (
          <BaseLink id={uniqueIdStorage.generateUniqueId(textContent)} href={node.data.uri}>
            {children}
          </BaseLink>
        );
      },
      ...renderNode,
    },
    ...otherRenderOptions,
  });
}
